import { createSlice } from '@reduxjs/toolkit'
import {
    DocumentList,
    InfoCenterDocumentCategoryList,
    InfoCenterDocumentSubCategoryList
} from './thunk'

export const initialState = {
    InfoCenterDocumentCategory: {
        list: [],
        loading: false,
        totalPage: 1,
        totalRecords: 1,
        page: 1
    },
    InfoCenterDocumentSubCategory: {
        list: [],
        loading: false,
        totalPage: 1,
        totalRecords: 1,
        page: 1
    },
    DocumentUpload: {
        list: [],
        loading: false
    }
}
const InfoCenter = createSlice({
    name: '@infoCenter',
    initialState,
    reducers: {
        //
    },
    extraReducers: (builder) => {
        // Listing
        builder.addCase(InfoCenterDocumentCategoryList.pending, (state) => {
            state.InfoCenterDocumentCategory.loading = true
        })
        builder.addCase(InfoCenterDocumentCategoryList.fulfilled, (state, action) => {
            const { data, page, totalPage, totalRecords } = action.payload
            state.InfoCenterDocumentCategory.list = data
            state.InfoCenterDocumentCategory.page = page
            state.InfoCenterDocumentCategory.totalPage = totalPage
            state.InfoCenterDocumentCategory.totalRecords = totalRecords
            state.InfoCenterDocumentCategory.loading = false
        })
        builder.addCase(InfoCenterDocumentCategoryList.rejected, (state) => {
            state.InfoCenterDocumentCategory.loading = false
        })

        //

        // Sub Listing
        builder.addCase(InfoCenterDocumentSubCategoryList.pending, (state) => {
            state.InfoCenterDocumentSubCategory.loading = true
        })
        builder.addCase(InfoCenterDocumentSubCategoryList.fulfilled, (state, action) => {
            const { data, page, totalPage, totalRecords } = action.payload
            state.InfoCenterDocumentSubCategory.list = data
            state.InfoCenterDocumentSubCategory.page = page
            state.InfoCenterDocumentSubCategory.totalPage = totalPage
            state.InfoCenterDocumentSubCategory.totalRecords = totalRecords
            state.InfoCenterDocumentSubCategory.loading = false
        })
        builder.addCase(InfoCenterDocumentSubCategoryList.rejected, (state) => {
            state.InfoCenterDocumentSubCategory.loading = false
        })

        //

        // Document List
        builder.addCase(DocumentList.pending, (state) => {
            state.DocumentUpload.loading = true
        })
        builder.addCase(DocumentList.fulfilled, (state, action) => {
            const { data } = action.payload
            state.DocumentUpload.list = data
            state.DocumentUpload.loading = false
        })
        builder.addCase(DocumentList.rejected, (state) => {
            state.DocumentUpload.loading = false
        })
    }
})

export default InfoCenter.reducer